import React from 'react';
import PropTypes from 'prop-types';
import utils from '@utils';
import PaymentHistoryItem from './PaymentHistoryItem';

/**
 * Displays a summary of refunds, including total refunds and a list of refund history items.
 *
 * @component
 * @param {Object} props
 * @param {Object} props.totals - An object containing total refund amounts.
 * @param {number} props.totals.refunds - The total amount of refunds.
 * @param {Array<Object>} props.paymentHistory - Array of payment history items, each representing a payment or refund.
 * @param {Array<Object>} props.refundsInTransit - Array of refund items that are currently in transit.
 * @returns {JSX.Element} The rendered RefundsDisplay component.
 */
const RefundsDisplay = ({ totals, paymentHistory, refundsInTransit }) => {
  const { lang } = global;

  const refundedPayments = paymentHistory.filter(item => item.Amount < 0);

  return (
    <div className="row">
      <div className="col-xs-9">
        <strong>{lang.t("Refund(s)")}</strong>
      </div>
      <div className="col-xs-3">
        {utils.currencyFormatter(totals.refunds)}
      </div>
      <div className="col-xs-12">
        {refundedPayments.map(item => (
          <PaymentHistoryItem
            key={`refund_${item.Id}`}
            item={item}
            keyPrefix="refund"
          />
        ))}
        {refundsInTransit.map((item, index) => (
          <PaymentHistoryItem
            key={`refund_in_transit_${item.Id || index}`}
            item={item}
            keyPrefix="refund_in_transit"
          />
        ))}
      </div>
    </div>
  );
};

RefundsDisplay.propTypes = {
  totals: PropTypes.shape({
    refunds: PropTypes.number.isRequired
  }).isRequired,
  paymentHistory: PropTypes.array.isRequired,
  refundsInTransit: PropTypes.array.isRequired
};

export default RefundsDisplay;
